import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IVisaTransactionStatusDataTableRowFormMeta {
  date: FormInputMeta,
  acquirerReference: FormInputMeta,
  acquirerBIN: FormInputMeta,
  merchant: FormInputMeta,
  accountNumber: FormInputMeta,
  amount: FormInputMeta,
  currency: FormInputMeta,
  authorization: FormInputMeta,
  pres1: FormInputMeta,
  reversal1: FormInputMeta,
  firstCharge: FormInputMeta,
  reversal2: FormInputMeta,
  pres2: FormInputMeta,
  reversal3: FormInputMeta,
  //
  schema: any,
}

const VisaTransactionStatusDataTableRowFormMeta = {} as IVisaTransactionStatusDataTableRowFormMeta;

VisaTransactionStatusDataTableRowFormMeta.date = {
  name: 'date',
  type: 'date',
  label: 'Date',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
VisaTransactionStatusDataTableRowFormMeta.acquirerReference = {
  name: 'acquirerReference',
  type: 'text',
  label: 'N° Ref: acquereur',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
VisaTransactionStatusDataTableRowFormMeta.acquirerBIN = {
  name: 'acquirerBIN',
  type: 'text',
  label: 'BIN acquereur',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
VisaTransactionStatusDataTableRowFormMeta.merchant = {
  name: 'merchant',
  type: 'text',
  label: 'Commercant',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
VisaTransactionStatusDataTableRowFormMeta.accountNumber = {
  name: 'accountNumber',
  type: 'text',
  label: 'N° Compte',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
VisaTransactionStatusDataTableRowFormMeta.amount = {
  name: 'amount',
  type: 'text',
  label: 'Montant',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
VisaTransactionStatusDataTableRowFormMeta.currency = {
  name: 'currency',
  type: 'text',
  label: 'Devise',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
VisaTransactionStatusDataTableRowFormMeta.authorization = {
  name: 'authorization',
  type: 'text',
  label: 'Autorisation',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
VisaTransactionStatusDataTableRowFormMeta.pres1 = {
  name: 'pres1',
  type: 'text',
  label: 'Pres.',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
VisaTransactionStatusDataTableRowFormMeta.reversal1 = {
  name: 'reversal1',
  type: 'text',
  label: 'Reversal',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
VisaTransactionStatusDataTableRowFormMeta.firstCharge = {
  name: 'firstCharge',
  type: 'text',
  label: '1st Charg.',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
VisaTransactionStatusDataTableRowFormMeta.reversal2 = {
  name: 'reversal2',
  type: 'text',
  label: 'Reversal',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
VisaTransactionStatusDataTableRowFormMeta.pres2 = {
  name: 'pres2',
  type: 'text',
  label: 'Pres.',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
VisaTransactionStatusDataTableRowFormMeta.reversal3 = {
  name: 'reversal3',
  type: 'text',
  label: 'Reversal',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};

VisaTransactionStatusDataTableRowFormMeta.schema = yup.object().shape(getValidationSchema(VisaTransactionStatusDataTableRowFormMeta));

export default VisaTransactionStatusDataTableRowFormMeta;
